const MultipleChoiceIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
		{/* Choice A */}
		<text x="2" y="8" fontSize="7" fontWeight="bold" fill="currentColor" textAnchor="middle">A</text>
		<rect x="7" y="5.2" width="8" height="1.6" rx="0.8" fill="currentColor" />

		{/* Choice B */}
		<text x="2" y="15" fontSize="7" fontWeight="bold" fill="currentColor" textAnchor="middle">B</text>
		<rect x="7" y="11.2" width="8" height="1.6" rx="0.8" fill="currentColor" />
	</svg>
);

export default MultipleChoiceIcon;